<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><a id="ad_card_1"></a><p class="ach"><span class="small">ALSO BY</span> R<span class="small">OBERT</span> H<span class="small">ELLENGA</span></p><p class="acl"><em>The Sixteen Pleasures</em></p><p class="acl"><em>The Fall of a Sparrow</em></p><p class="acl"><em>Blues Lessons</em></p><p class="acl"><em>Philosophy Made Simple</em></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ItalianLover_ad_card_1.vue?bbd59752